import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-retiro-total',
  templateUrl: './retiro-total.component.html',
  styleUrls: ['./retiro-total.component.scss']
})
export class RetiroTotalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
